const PROCUREMENT_PLAN_TYPES = {
  PLANNING: "PROCUREMENTPLANNING",
  EXECUTION: "PROCUREMENTEXECUTION",
};

export default PROCUREMENT_PLAN_TYPES;
